import script from "./SlideDesignPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideDesignPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SlideDesignPanel.vue?vue&type=style&index=0&id=93e8361c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93e8361c"]])

export default __exports__